import {Helmet} from "react-helmet";
import {RouteHelper} from "../../../route/RouteHelper";
import {css} from "@emotion/css";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne, RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import Tab from "@mui/material/Tab";
import React, {useState} from "react";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import TabPanel from "@mui/lab/TabPanel";
import FundDetailBasicInfo from "./FundDetailBasicInfo";
import FundDetailGateway from "./FundDetailGateway";

export default function FundDetail() {

    const {id: fundId = -1} = useParams()
    const {state} = useLocation()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineWriterDetail.name);

    const navigate = useNavigate()

    const [value, setValue] = useState(tabTypes.Info.id);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.FundDetail.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.FundsList.name,
                                    RouteHelper.FundsList.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""),
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>


                    <TabContext value={value}>
                        <TabBoxContainer>
                            <TabList onChange={handleChange} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={tabTypes.Info.title}
                                     value={tabTypes.Info.id}
                                />
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={tabTypes.Gateway.title}
                                     value={tabTypes.Gateway.id}
                                />
                            </TabList>
                        </TabBoxContainer>

                        <TabPanel value={tabTypes.Info.id}>
                            <FundDetailBasicInfo/>
                        </TabPanel>

                        <TabPanel value={tabTypes.Gateway.id}>
                            <FundDetailGateway/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


const tabTypes = {
    Info: {
        id: "info",
        title: "اطلاعات پایه"
    }, Gateway: {
        id: "gateway",
        title: "درگاه پرداخت"
    },
}